// extracted by mini-css-extract-plugin
module.exports = {"noResults":"_f40e0a7"};